import React from 'react';
import { UserModel } from 'models';
import { IconButton } from '@mui/material';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';

export default function UserStatistics({ id, title = 'آمار' }) {
  return (
    <>
      <UserModel
        isPopup
        isAssign={false}
        disabled={false}
        multiSelect={false}
        title={title}
        // onAssign={onAssign}
        assigning={false}
        initFilter={{ coupon_id: id, used_this_coupon: 'HAVE' }}
        preSelected={[]}
        action={
          <IconButton size="small" color="info" sx={{ bgcolor: 'info.lighter' }}>
            <InsightsRoundedIcon fontSize='small' />
          </IconButton>
        }
      />
    </>
  );
}
